/**
 * Utility function to decode and extract user role from ID token
 * @returns {string} User role from token or 'employee' as default
 */
export const getUserRoleFromToken = () => {
    try {
      const token = localStorage.getItem("idToken")
      if (!token) return "employee"
  
      const payload = token.split(".")[1]
      const decodedPayload = JSON.parse(atob(payload))
  
      return decodedPayload.user_role || "employee"
    } catch (error) {
      console.error("Error decoding token:", error)
      return "employee"
    }
  }
  
  /**
   * Utility function to get full user data from ID token
   * @returns {object} User data from token or empty object
   */
  export const getUserDataFromToken = () => {
    try {
      const token = localStorage.getItem("idToken")
      if (!token) return {}
  
      const payload = token.split(".")[1]
      const decodedPayload = JSON.parse(atob(payload))
  
      return {
        name: decodedPayload.name || "",
        email: decodedPayload.email || "",
        picture: decodedPayload.picture || "",
        user_role: decodedPayload.user_role || "employee",
        department: decodedPayload.department || "",
        sub: decodedPayload.sub || "",
      }
    } catch (error) {
      console.error("Error decoding token:", error)
      return {}
    }
  }
  
  /**
   * Utility function to check if user has admin role
   * @returns {boolean} True if user is admin
   */
  export const isAdmin = () => {
    const role = getUserRoleFromToken()
    return role === "admin"
  }
  
  /**
   * Utility function to check if user has manager role
   * @returns {boolean} True if user is manager
   */
  export const isManager = () => {
    const role = getUserRoleFromToken()
    return role === "manager"
  }
  
  /**
   * Utility function to format role name for display
   * @param {string} role - Raw role string
   * @returns {string} Formatted role name
   */
  export const formatRoleName = (role) => {
    if (!role) return "Employee"
    
    return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
  }
  
  /**
   * Utility function to get role color for UI
   * @param {string} role - User role
   * @returns {string} Color code for the role
   */
  export const getRoleColor = (role) => {
    switch (role?.toLowerCase()) {
      case "admin":
        return "#d32f2f" // Red
      case "manager":
        return "#ed6c02" // Orange
      case "employee":
      default:
        return "#20d5d5" // Teal
    }
  }
  
  /**
   * Utility function to get role icon emoji
   * @param {string} role - User role
   * @returns {string} Emoji for the role
   */
  export const getRoleIcon = (role) => {
    switch (role?.toLowerCase()) {
      case "admin":
        return "👑"
      case "manager":
        return "🎯"
      case "employee":
      default:
        return "👤"
    }
  }